import { CpsUiAdminConfigType, CpsUiAdminConfigWriteType } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class UiAdminConfigsService {
  public async getUiAdminConfigEntry(key: CpsUiAdminConfigType): Promise<string> {
    return ExecuteEndpoint(`ui-admin-config-entries/${key}`, 'GET');
  }

  public async upsertUiAdminConfigEntry(key: CpsUiAdminConfigType, body: string): Promise<void> {
    return ExecuteEndpoint(`ui-admin-config-entries/${key}`, 'POST', {
      body,
      headers: {
        Accept: 'text/plain',
        'Content-Type': 'text/plain'
      }
    });
  }

  public async getUiAdminConfigWritePermissions(keys: string[]): Promise<CpsUiAdminConfigWriteType> {
    const queryString = keys.map(i => `keys=${i}`).join('&');
    return ExecuteEndpoint(`ui-admin-config-entries/write-permissions?${queryString}`, 'GET');
  }
}
